import { all, fork, call, put, takeLatest } from 'redux-saga/effects'

import { constants } from '../../modules/jobFunctions/jobStopCallActions'
import * as api from '../../api/job/stopCalls'

function* stopCallsRefresh(action) {
  try {
    const payload = yield call(api.getJobStopCalls, action.jobId)
    yield put({ type: constants.STOP_CALLS_REFRESH.SUCCESS, payload })
    action.callback && action.callback(payload)
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.STOP_CALLS_REFRESH.FAILED,
      message: e.message || e
    })
  }
}

function* watchStopCalls() {
  yield takeLatest(constants.STOP_CALLS_REFRESH.ACTION, stopCallsRefresh)
}

function* sagaCreateStopCall(action) {
  try {
    const payload = {
      job_id: action.jobId,
      content: action.content
    }
    yield call(api.createStopCall, payload)
    yield put({ type: constants.STOP_CALL_CREATE.SUCCESS, payload })
    yield call(stopCallsRefresh, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.STOP_CALL_CREATE.FAILED,
      message: e.message || e
    })
  }
}

function* watchCreateStopCall() {
  yield takeLatest(constants.STOP_CALL_CREATE.ACTION, sagaCreateStopCall)
}

function* sagaUpdateStopCall(action) {
  try {
    const payload = {
      job_id: action.jobId,
      stop_call_id: action.stopCallId,
      content: action.content
    }
    yield call(api.updateStopCall, payload)
    yield put({ type: constants.STOP_CALL_UPDATE.SUCCESS, payload })
    yield call(stopCallsRefresh, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.STOP_CALL_UPDATE.FAILED,
      message: e.message || e
    })
  }
}

function* watchUpdateStopCall() {
  yield takeLatest(constants.STOP_CALL_UPDATE.ACTION, sagaUpdateStopCall)
}

function* sagaDeleteStopCall(action) {
  try {
    const payload = {
      stopCallId: action.stopCallId
    }
    yield call(api.deleteStopCall, payload)
    yield put({ type: constants.STOP_CALL_DELETE.SUCCESS, payload })
    yield call(stopCallsRefresh, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.STOP_CALL_DELETE.FAILED,
      message: e.message || e
    })
  }
}

function* watchDeleteStopCall() {
  yield takeLatest(constants.STOP_CALL_DELETE.ACTION, sagaDeleteStopCall)
}

// ATTACHMENT SAGAS
function* uploadStopCallAttachments(action) {
  try {
    const payload = {
      formData: action.formData,
      stopCallId: action.stopCallId
    }

    yield call(api.uploadStopCallAttachments, payload)
    yield put({ type: constants.UPLOAD_STOP_CALL_ATTACHMENT.SUCCESS, payload })
    yield call(fetchStopCallAttachments, { stopCallId: action.stopCallId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.UPLOAD_STOP_CALL_ATTACHMENT.FAILED,
      message: e.message || e
    })
  }
}

function* watchUploadStopCallAttachments() {
  yield takeLatest(constants.UPLOAD_STOP_CALL_ATTACHMENT.ACTION, uploadStopCallAttachments)
}

function* fetchStopCallAttachments(action) {
  try {
    const payload = yield call(api.fetchStopCallAttachments, action.stopCallId)
    yield put({ type: constants.FETCH_STOP_CALL_ATTACHMENTS.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.FETCH_STOP_CALL_ATTACHMENTS.FAILED,
      message: e.message || e
    })
  }
}

function* watchFetchStopCallAttachments() {
  yield takeLatest(constants.FETCH_STOP_CALL_ATTACHMENTS.ACTION, fetchStopCallAttachments)
}

function* updateStopCallAttachmentDescription(action) {
  try {
    const payload = {
      attachmentId: action.attachmentId,
      description: action.description
    }
    yield call(api.updateAttachmentDescription, payload)
    yield put({ type: constants.UPDATE_STOP_CALL_ATTACHMENT_DESCRIPTION.SUCCESS, payload })
    yield call(fetchStopCallAttachments, { stopCallId: action.stopCallId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.UPDATE_STOP_CALL_ATTACHMENT_DESCRIPTION.FAILED,
      message: e.message || e
    })
  }
}

function* watchUpdateStopCallAttachmentDescription() {
  yield takeLatest(
    constants.UPDATE_STOP_CALL_ATTACHMENT_DESCRIPTION.ACTION,
    updateStopCallAttachmentDescription
  )
}

function* deleteStopCallAttachment(action) {
  try {
    const payload = {
      attachmentId: action.attachmentId
    }

    yield call(api.deleteStopCallAttachment, payload)
    yield put({ type: constants.DELETE_STOP_CALL_ATTACHMENT.SUCCESS, payload })
    yield call(fetchStopCallAttachments, { stopCallId: action.stopCallId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.DELETE_STOP_CALL_ATTACHMENT.FAILED,
      message: e.message || e
    })
  }
}

function* watchDeleteStopCallAttachments() {
  yield takeLatest(constants.DELETE_STOP_CALL_ATTACHMENT.ACTION, deleteStopCallAttachment)
}

function* notesRefresh(action) {
  try {
    const payload = yield call(api.getStopCallNotes, action.stopCallId)
    yield put({ type: constants.STOP_CALL_NOTES_REFRESH.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.STOP_CALL_NOTES_REFRESH.FAILED,
      message: e.message || e
    })
  }
}

function* watchNotes() {
  yield takeLatest(constants.STOP_CALL_NOTES_REFRESH.ACTION, notesRefresh)
}

function* sagaCreateNote(action) {
  try {
    const payload = {
      stopCallId: action.stopCallId,
      content: action.content
    }
    yield call(api.createNote, payload)
    yield put({ type: constants.STOP_CALL_NOTE_CREATE.SUCCESS, payload })
    yield call(notesRefresh, { stopCallId: action.stopCallId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.STOP_CALL_NOTE_CREATE.FAILED,
      message: e.message || e
    })
  }
}

function* watchCreateNote() {
  yield takeLatest(constants.STOP_CALL_NOTE_CREATE.ACTION, sagaCreateNote)
}

function* sagaUpdateNote(action) {
  try {
    const payload = {
      stopCallId: action.stopCallId,
      note_id: action.noteId,
      content: action.content,
      updated_by_id: action.userId
    }
    yield call(api.updateNote, payload)
    yield put({ type: constants.STOP_CALL_NOTE_UPDATE.SUCCESS, payload })
    yield call(notesRefresh, { stopCallId: action.stopCallId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.STOP_CALL_NOTE_UPDATE.FAILED,
      message: e.message || e
    })
  }
}

function* watchUpdateNote() {
  yield takeLatest(constants.STOP_CALL_NOTE_UPDATE.ACTION, sagaUpdateNote)
}

function* sagaDeleteNote(action) {
  try {
    const payload = {
      note_id: action.noteId
    }
    yield call(api.deleteNote, payload)
    yield put({ type: constants.STOP_CALL_NOTE_DELETE.SUCCESS, payload })
    yield call(notesRefresh, { stopCallId: action.stopCallId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.STOP_CALL_NOTE_DELETE.FAILED,
      message: e.message || e
    })
  }
}

function* watchDeleteNote() {
  yield takeLatest(constants.STOP_CALL_NOTE_DELETE.ACTION, sagaDeleteNote)
}

/**
 * Export the root saga by forking all available sagas.
 */
export function* rootSaga() {
  // add more sagas here
  yield all([
    fork(watchStopCalls),
    fork(watchCreateStopCall),
    fork(watchUpdateStopCall),
    fork(watchDeleteStopCall),

    fork(watchUploadStopCallAttachments),
    fork(watchFetchStopCallAttachments),
    fork(watchUpdateStopCallAttachmentDescription),
    fork(watchDeleteStopCallAttachments),

    fork(watchNotes),
    fork(watchCreateNote),
    fork(watchUpdateNote),
    fork(watchDeleteNote)
  ])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/jobFunctions/jobStopCallSaga.js